import { useRef, useEffect } from 'react';
import { EditorView } from '@codemirror/view';
import { EditorState } from '@codemirror/state';
import { python } from '@codemirror/lang-python';
import { oneDark } from '@codemirror/theme-one-dark';
import { quietlight } from '@uiw/codemirror-themes-all';
import { useTheme } from '../context/ThemeContext';

/**
 * Только чтение, подсветка Python (CodeMirror 6).
 */
export default function ReadOnlyPythonCode({ value, className = '' }) {
  const hostRef = useRef(null);
  const { theme } = useTheme();

  useEffect(() => {
    const parent = hostRef.current;
    if (!parent) return undefined;
    const doc = value ?? '';
    const themeExt = theme === 'dark' ? oneDark : quietlight;
    const state = EditorState.create({
      doc,
      extensions: [
        python(),
        themeExt,
        EditorView.editable.of(false),
        EditorState.readOnly.of(true),
        EditorView.lineWrapping,
      ],
    });
    const view = new EditorView({ state, parent });
    return () => {
      view.destroy();
    };
  }, [value, theme]);

  return <div ref={hostRef} className={`read-only-python-cm ${className}`.trim()} />;
}
